import { useState } from 'react';
import { MdPublic } from 'react-icons/md';
import { ProductItem } from '@/lib/types/api';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import { pushDataLayer } from '@/lib/utilities/analytics/gtm';

export function ProductDescription({
  product,
}: Readonly<{ product: ProductItem }>) {
  const [showEnglishDescriptions, setShowEnglishDescriptions] = useState(false);
  const { locale } = useRouter();
  function handleLanguageToggle() {
    setShowEnglishDescriptions(!showEnglishDescriptions);
    pushDataLayer('buttonClick', {
      label: 'Show description in original language',
    });
  }
  const description = showEnglishDescriptions
    ? product.description_en
    : product.description;
  const { t } = useTranslation();
  return (
    <div className='w-full space-y-4 bg-[#F7F7F7] px-4 py-12 text-sm font-light'>
      <div className='xl:max-w-[50%]'>
        <div
          className={classNames('flex cursor-pointer items-center space-x-2', {
            hidden: locale === 'en-US',
          })}
          onClick={handleLanguageToggle}
        >
          <MdPublic className='h-6 w-6' />
          <span className='language-toggle'>
            {showEnglishDescriptions
              ? t('products:SHOW_AUTOMATIC_TRANSLATION')
              : t('products:SHOW_IN_ORIGINAL_LANGUAGE')}
          </span>
        </div>
        <p
          className='text-lg font-light  text-muted-500'
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </div>
  );
}
